// extracted by mini-css-extract-plugin
export default {"githubHeading":"GIthub_githubHeading__8UAK4","GitHubCalendar":"GIthub_GitHubCalendar__F2Mxy"};